import * as yup from 'yup';

export const initialValues = {
  eventNumber: '',
  eventName: '',
  eventDate: '',
  eventType: '',
};

export const schema = yup.object().shape({
  eventNumber: yup.string(),
  eventName: yup.string(),
  eventDate: yup.string(),
  eventType: yup.string(),
});
